import { AxiosResponse } from 'axios';
import React, { useState, useEffect } from 'react';
import CustomReCAPTCHA from '../CustomCaptcha';
import { DateObject } from "react-multi-date-picker"
import { TransactionService } from '../../services/TransactionService';
import { ITransaction, ITransactionWebModelRequest } from "../../requests/ITransactionWebModelRequest";
import { TFunction, withTranslation } from 'react-i18next';
import "./TransactionReport.css"
import { allAcquirersFilters, allPaymentModesArg, allPaymentModesUru } from "../../models/TransactionReportConstants"
import { Option } from "../../models/Option"
import { WebCache } from "../../services/WebCache";
import { IIssuer } from "../../models/IIssuer";
import TerminalLocation from "../TerminalLocation";
import ErrorsView from '../ErrorsView';
import { UtilService } from "../../services/UtilService";
import { toast } from 'react-toastify';
import TextField from '../controls/fields/textField';
import NumericField from '../controls/fields/numericField';
import SelectField from '../controls/fields/selectField';
import DateField from '../controls/fields/dateField';
import Button from '../controls/buttons/button';
import { OptionMapperHelper } from '../../helpers/OptionMapperHelper';
import Page from '../containers/page'
import FormFilter from '../containers/form-filter';
import CustomTable, { TableModeEnum } from '../table/CustomTable';
import { IIssuerTotalDto } from '../../models/IIssuerTotalDto';
import { DateHelper } from '../../helpers/DateHelper';
import NavigationTabLinksForTransactions from './NavigationTabLinksForTransactions';
import { Modal } from 'react-bootstrap';
import { TransactionColumns } from './TransactionsColumns';
import { useMessages } from "../MessagesContext";
import Pagination from '../../components/Pagination'
import { CurrencyHelper } from '../../helpers/CurrencyHelper';
import TotalTransactions from '../charges/TotalTransactions';

interface IProps {
    t: TFunction
}
interface IFilters {
    fromDate: DateObject,
    toDate: DateObject,
    operationTypeFilter: string,
    initQuestionFilter: string,
    groupFilter: string,
    ticketFilter: string,
    batchFilter: string,
    transactionStateFilter: string,
    terminalFilter: string,
    authorizationCodeFilter: string,
    authTerminalFilter: string,
    amountFilter: string,
    amountToCustomerFilter: string,
    merchantFilter: string,
    transactionIdFilter: string
    cardNumberIdFilter: string,
    muIdFilter: string,
    paymentModeFilter: string,
    acquirerFilter: string,
    issuerFilter: string,
    departmentFilter: string,
    locationFilter: string,
    branchFilter: string,
    taxPayerFilter: string[],
    responseCodeSelected: string | null,
    currencySelected: string | null
}

const pageSize = 20;
const pageQuantity = 3
const defaultPages = [1, 2, 3]
const T_PREFIX: string = 'pages.reportTransactions.';

const TransactionReport: React.FC<IProps> = ({ t }: IProps) => {
    const allTransactionStatesFilter = localStorage.getItem("_transactionStatesCode") ? JSON.parse(localStorage.getItem("_transactionStatesCode") as string) : [];
    const allResponseCodes = localStorage.getItem("_transactionResponseCode") ? JSON.parse(localStorage.getItem("_transactionResponseCode") as string) : [];
    const allOperationTypesFilters = localStorage.getItem("_transactionTypesCode") ? JSON.parse(localStorage.getItem("_transactionTypesCode") as string) : [];

    const buildPaymentModesSelectOptions = (): Array<Option> => {
        let respondCodes: Array<Option> = [
            { value: "", label: t("all"), key: "all" } as Option
        ];
        const allPaymentModes = WebCache.isUserARG() ? allPaymentModesArg : allPaymentModesUru;
        const responseCodes: Array<HTMLOptionElement> = new OptionMapperHelper(t).buildSelectOptionsFromEnum(allPaymentModes, 'channel-') as Array<HTMLOptionElement>;
        respondCodes.push(...responseCodes);
        return respondCodes;
    }
    let [dateFrom, dateTo] = DateHelper.buildDateRange();
    const [filters, setFilters] = useState<IFilters>({ fromDate: dateFrom, toDate: dateTo, operationTypeFilter: "", initQuestionFilter: "", groupFilter: "", ticketFilter: "", batchFilter: "", transactionStateFilter: "", terminalFilter: "", authorizationCodeFilter: "", authTerminalFilter: "", amountFilter: "", amountToCustomerFilter: "", merchantFilter: "", transactionIdFilter: "", cardNumberIdFilter: "", muIdFilter: "", paymentModeFilter: "", acquirerFilter: "", issuerFilter: "", departmentFilter: "", locationFilter: "", branchFilter: "", taxPayerFilter: [], responseCodeSelected: "", currencySelected: "" });
    const [shouldFetch, setShouldFetch] = useState(false);
    const [activePage, setActivePage] = useState<number>(1);
    const [mainPage, setMainPage] = useState<number>(0);
    const [pages, setPages] = useState<number[]>(defaultPages);
    const [transactions, setTransactions] = useState<ITransaction[]>([])
    const [currentIssuers, setCurrentIssuers] = useState<IIssuer[]>(WebCache.getAllIssuers());
    const [currencies, setCurrencies] = useState<Option[]>(UtilService.getCurrencyOptions());
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(sessionStorage.getItem('captchaVerified') == "true");
    const [errors, setErrors] = useState<string[]>([]);
    const [gridFormat, setGridFormat] = useState<"grid" | "list">("list")
    const [tranId, setTranId] = useState<string>("")
    const [show, setShow] = useState<boolean>(false)
    const [issuerByTotal, setIssuerByTotal] = useState<IIssuerTotalDto[]>([])
    const [responseCodes, setResponseCodes] = useState<Option[]>(new OptionMapperHelper(t).buildTransactionSelectOptions(allResponseCodes, true))
    const [paymentModes, setPaymentModes] = useState<Option[]>(buildPaymentModesSelectOptions())
    const [rowDetail, setRowDetail] = useState<{ title: string; total: string; data: Array<{ prop: string; value: string }> } | null>(null)
    const [taxPayerName, setTaxPayerName] = useState<string>("")
    const [departmentName, setDepartmentName] = useState<string>("")
    const [locationName, setLocationName] = useState<string>("")
    const [branchName, setBranchName] = useState<string>("")
    const [maxDayRange, setMaxDayRange] = useState<number>(15)
    const messages = useMessages();
    const divColumnSize: string = UtilService.isMobilePlatform() ? "col-md-6" : "col-sm-12 col-md-4 col-lg-3";
    
    const handleCaptchaVerify = (onVerify: boolean) => {
        setIsCaptchaVerified(onVerify);
    };

    const getTransactionRequest = (all: boolean) => {
        let from_year: number;
        let from_month: number;
        let from_day: number;
        let to_year: number;
        let to_month: number;
        let to_day: number;
        from_year = filters.fromDate.year;
        from_month = filters.fromDate.month.number;
        from_day = filters.fromDate.day;
        to_year = filters.toDate.year;
        to_month = filters.toDate.month.number;
        to_day = filters.toDate.day;

        const getIdOfFilter = (value: string) => {// Obtiene el id del filtro de transaccion seleccionado, este separado por "-"
            return value === "" ? value : value.split("-")[1];
        };
        const tranWebModel: ITransactionWebModelRequest = {
            From: new Date(from_year, from_month - 1,
                from_day,
                filters.fromDate.hour - 3,
                filters.fromDate.minute).toJSON(),
            To: new Date(to_year,
                to_month - 1,
                to_day,
                filters.toDate.hour - 3,
                filters.toDate.minute).toJSON(),
            Terminals: (filters.terminalFilter == null || filters.terminalFilter == "") ? [] : [WebCache.getCurrentUser()?.countryId == 1 ? "B24_" + filters.terminalFilter : filters.terminalFilter],
            TransactionState: (filters.transactionStateFilter == null || filters.transactionStateFilter == "") ? [] : filters.transactionStateFilter.split("-").map(Number),
            TerminalGroup: (filters.groupFilter == null || filters.groupFilter == "") ? "" : filters.groupFilter,
            InitQuestion: (filters.initQuestionFilter == null || filters.initQuestionFilter == "") ? "" : filters.initQuestionFilter,
            OperationType: (filters.operationTypeFilter == null) ? "" : (getIdOfFilter(filters.operationTypeFilter)),
            AuthTerminal: (filters.authTerminalFilter == null || filters.authTerminalFilter == "") ? "" : filters.authTerminalFilter,
            Amount: (filters.amountFilter == null || filters.amountFilter == "") ? "" : filters.amountFilter,
            AmountToCustomer: (filters.amountToCustomerFilter == null || filters.amountToCustomerFilter == "") ? "" : filters.amountToCustomerFilter,
            MerchantCodes: (filters.merchantFilter === null || filters.merchantFilter == "") ? [] : [filters.merchantFilter],
            AuthorizationCode: (filters.authorizationCodeFilter == null || filters.authorizationCodeFilter == "") ? "" : filters.authorizationCodeFilter,
            Issuer: (filters.issuerFilter == null || filters.issuerFilter == "0000") ? "" : filters.issuerFilter,
            Department: (filters.departmentFilter == null || filters.departmentFilter == "0000") ? "" : filters.departmentFilter,
            Location: (filters.locationFilter == null || filters.locationFilter == "0000") ? "" : filters.locationFilter,
            PayerTaxIds: filters.taxPayerFilter.includes("all") ? [] : filters.taxPayerFilter.filter(x => x.length > 0),
            Branch: (filters.branchFilter == null || filters.branchFilter == "0000") ? "" : filters.branchFilter,
            Acquirer: (filters.acquirerFilter == null || filters.acquirerFilter == "0000") ? "" : filters.acquirerFilter,
            TransactionId: (filters.transactionIdFilter == null || filters.transactionIdFilter == "") ? "" : filters.transactionIdFilter,
            CardNumber: (filters.cardNumberIdFilter == null || filters.cardNumberIdFilter == "") ? "" : filters.cardNumberIdFilter,
            MuId: (filters.muIdFilter == null || filters.muIdFilter == "") ? "" : filters.muIdFilter,
            TicketNumber: (filters.ticketFilter == null || filters.ticketFilter == "") ? "" : filters.ticketFilter,
            BatchNumber: (filters.batchFilter == null || filters.batchFilter == "") ? "" : filters.batchFilter,
            PaymentMode: (filters.paymentModeFilter == null || filters.paymentModeFilter == "") ? "" : filters.paymentModeFilter,
            Currency: (filters.currencySelected == null || filters.currencySelected == "") ? "" : filters.currencySelected,
            ResponseCode: (filters.responseCodeSelected == null || filters.responseCodeSelected == "") ? "" : (getIdOfFilter(filters.responseCodeSelected)),
            Skip: all ? 0 : (mainPage * pageSize * pageQuantity),
            Take: all ? 0 : ((pageSize * pageQuantity) + 1)
        };
        return tranWebModel;
    }

    const getTransactions = () => {

        let dateFrom = DateHelper.dateObjectToDate(filters.fromDate);
        let dateTo = DateHelper.dateObjectToDate(filters.toDate);
        let diffDays = Math.round((dateTo.getTime() - dateFrom.getTime()) / (1000 * 3600 * 24));
        if (diffDays > maxDayRange) {
            toast.error(`La busqueda no puede superar los ${maxDayRange} días`);
            return;
        }

        TransactionService.getAll(getTransactionRequest(false)).then((response: AxiosResponse<ITransaction[]>) => {
            if (response == null || response.data == null || response.data.length == 0) {
                setTransactions([]);
                setErrors([])
            }
            setTransactions(response.data)
            setErrors([])
        }).catch(error => {
            setErrors(error.response.data)
            console.log('error:', error);
        }
        );
    }

    const getTransactionsToExcel = () => {
        if (isCaptchaVerified) {
            messages.showDownloadMessage();
            TransactionService.getAllToExcel(getTransactionRequest(true))
                .then((response: AxiosResponse<Blob>) => {
                })
                .catch((error) => {
                    setErrors(error.response.data)
                    console.log('error:', error);
                });
        } else {
            toast.error("Por favor, verifica el CAPTCHA antes de descargar el archivo");
        }
    };

    const getFromBuscar = () => {
        setActivePage(1);
        setPages(defaultPages);
        setMainPage(0);
        getTransactions();
    }

    const clearFilters = () => {
        setFilters({
            ...filters,
            fromDate: dateFrom,
            toDate: dateTo,
            operationTypeFilter: "",
            initQuestionFilter: "",
            groupFilter: "",
            ticketFilter: "",
            batchFilter: "",
            transactionStateFilter: "",
            terminalFilter: "",
            authorizationCodeFilter: "",
            authTerminalFilter: "",
            amountFilter: "",
            amountToCustomerFilter: "",
            merchantFilter: "",
            transactionIdFilter: "",
            cardNumberIdFilter: "",
            muIdFilter: "",
            paymentModeFilter: "",
            acquirerFilter: "",
            issuerFilter: "",
            departmentFilter: "",
            locationFilter: "",
            branchFilter: "",
            taxPayerFilter: [],
            responseCodeSelected: "",
            currencySelected: ""
        });
        setShouldFetch(true); // Marca que hay que hacer fetch
    }

    //obtiene valores predeterminados cuando se hace clearFilters
    useEffect(() => {
        if (shouldFetch) {
            getFromBuscar();
            setShouldFetch(false); // Resetea la bandera
        }
    }, [filters, shouldFetch]);

    const getTicket = (tranId: string, transactionType: string) => {
        TransactionService.showTicket(tranId, transactionType)
    }

    const handleAcquirerFilterChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        let acquirerId = event.target.value;
        setFilters({
            ...filters,
            acquirerFilter: acquirerId,
            issuerFilter: "0000"
        })
        setCurrentIssuers(WebCache.getAllIssuers())
    }

    const getTotalsByIssuerAndCurrency = (tranId: string) => {
        TransactionService.getTotalsByIssuerAndCurrency(tranId).then((response: AxiosResponse<IIssuerTotalDto[]>) => {
            setShow(true)
            setIssuerByTotal(response.data)
            setTranId(tranId)
        }).catch(error => console.log('error:', error));
    }

    const processAction = (event: any, transaction: ITransaction) => {
        event.preventDefault();
        getTotalsByIssuerAndCurrency(transaction.id);
    }

    const transactionColumns = TransactionColumns({
        t,
        processAction,
        getTicket,
        showCouponColumn: true,
        setRowDetail
    });

    const buildIssuerSelectOptions = () => {
        let options: Array<HTMLOptionElement> = new OptionMapperHelper(t).buildSelectOptionsFromAnArrayWithDifferentInterface(currentIssuers, 'id', 'issuerName') as Array<HTMLOptionElement>;
        const todosIndex = options.findIndex(option => option.value === '0000');

        if (todosIndex !== -1) {
            const todosOption = options.splice(todosIndex, 1)[0];
            options = [todosOption, ...options];
        }
        options.sort((a, b) => {
            if (a.label === 'Todos') return -1;
            if (b.label === 'Todos') return 1;
            return a.label.localeCompare(b.label);
        });
        return options;
    }

    return (
        <Page>
            <>
                <TotalTransactions rowDetail={rowDetail} link={null}></TotalTransactions>
                <h2>{t(`sales`)}</h2>
                <div className='row'>
                    <div className='col-lg-12'>
                        <ErrorsView errors={errors} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <NavigationTabLinksForTransactions></NavigationTabLinksForTransactions>
                        <FormFilter
                            onSubmit={() => getFromBuscar()}
                            model={[filters, setFilters]}
                            clear={() => clearFilters()}
                            hidden={UtilService.isMobilePlatform() ? true : false}
                            header={
                                <div className="d-flex align-items-center justify-content-end">
                                    <button
                                        className={`btn ${gridFormat === "list" ? "btn-primary" : "btn-outline-primary"} me-2`}
                                        onClick={() => setGridFormat("list")}
                                    >
                                        <i className="fe fe-list"></i> {t("")}
                                    </button>
                                    <button
                                        className={`btn ${gridFormat === "grid" ? "btn-primary" : "btn-outline-primary"}`}
                                        onClick={() => setGridFormat("grid")}
                                    >
                                        <i className="fe fe-grid"></i> {t("")}
                                    </button>
                                </div>
                            }
                        >
                            <>
                                <div className="row">
                                    <div className={divColumnSize}>
                                        <DateField attr='fromDate' label={t(`${T_PREFIX}authDateTimeFrom`)} required={true}></DateField>
                                    </div>
                                    <div className={divColumnSize}>
                                        <DateField attr='toDate' label={t(`${T_PREFIX}authDateTimeTo`)} required={true}></DateField>
                                    </div>
                                    <div className={divColumnSize}>
                                        <SelectField attr='operationTypeFilter' label={t(`${T_PREFIX}transactionType`)} options={new OptionMapperHelper(t).buildTransactionSelectOptions(allOperationTypesFilters, false)}></SelectField>
                                    </div>
                                    <div className={divColumnSize}>
                                    <SelectField attr='transactionStateFilter' label={t(`${T_PREFIX}state`)} options={new OptionMapperHelper(t).buildTransactionSelectOptions(allTransactionStatesFilter, false, true)}></SelectField>
                                    </div>
                                    {WebCache.isUserUYU() ?
                                        <div className={divColumnSize}>
                                        <SelectField attr='acquirerFilter' label={t(`${T_PREFIX}acquirer`)} options={new OptionMapperHelper(t).buildSelectOptionsFromEnum(allAcquirersFilters, 'acquirer-')} onChange={(event) => handleAcquirerFilterChange(event)}></SelectField>                                                    
                                        </div>:<></>
                                    }
                                    <div className={divColumnSize}>
                                        <SelectField attr='issuerFilter' label={t(`${T_PREFIX}issuer`)} options={buildIssuerSelectOptions()}></SelectField>
                                    </div>
                                    <div className={divColumnSize}>
                                        <TextField attr='terminalFilter' label={t(`${T_PREFIX}terminal`)} ></TextField>
                                    </div>
                                    <div className={divColumnSize}>
                                        <TextField attr='merchantFilter' label={t(`${T_PREFIX}merchant`)}></TextField>
                                    </div>
                                    {WebCache.isUserUYU() ?
                                    <div className={divColumnSize}>
                                        <TextField attr='authTerminalFilter' label={t(`${T_PREFIX}authTerminal`)} ></TextField>
                                    </div>:<></>
                                    }
                                    {WebCache.isUserUYU() ?
                                        <div className={divColumnSize}>
                                            <NumericField attr='amountToCustomerFilter' label={t(`${T_PREFIX}amountToCustomer`)}></NumericField>
                                        </div> : <></>
                                    }
                                    <div className={divColumnSize}>
                                        <NumericField attr='amountFilter' label={t(`${T_PREFIX}amount`)}></NumericField>
                                    </div>
                                    <div className={divColumnSize}>
                                        <TextField attr='authorizationCodeFilter' label={t(`${T_PREFIX}authorizationCode`)}></TextField>
                                    </div>
                                    <div className={divColumnSize}>
                                        <TextField attr='transactionIdFilter' label={t(`${T_PREFIX}id`)}></TextField>
                                    </div>
                                    {WebCache.isUserUYU() ?
                                        <>
                                            <div className={divColumnSize}>
                                                <TextField attr='initQuestionFilter' label={t(`${T_PREFIX}initQuestion`)}></TextField>
                                            </div>
                                            <div className={divColumnSize}>
                                                <TextField attr='groupFilter' label={t(`${T_PREFIX}terminalGroup`)}></TextField>
                                            </div>
                                        </> : <></>
                                    }
                                    <TerminalLocation
                                        changeFilter={(taxPayerFilter, branchFilter, departmentFilter, locationFilter, departmentName, locationName, branchName, clientDocument) => {
                                            setFilters({
                                                ...filters,
                                                taxPayerFilter: taxPayerFilter,
                                                branchFilter: branchFilter,
                                                departmentFilter: departmentFilter,
                                                locationFilter: locationFilter,
                                            });
                                            setTaxPayerName(clientDocument);
                                            setDepartmentName(departmentName);
                                            setLocationName(locationName);
                                            setBranchName(branchName);
                                        }}
                                        filter={{
                                            taxPayerFilter: filters.taxPayerFilter,
                                            branchFilter: filters.branchFilter,
                                            departmentFilter: filters.departmentFilter,
                                            locationFilter: filters.locationFilter,
                                        }}
                                    />         
                                    <div className={divColumnSize}>
                                        <SelectField attr='currencySelected' label={t(`${T_PREFIX}currency`)} options={currencies} disabled={currencies.length === 1}></SelectField>
                                    </div>
                                    <div className={divColumnSize}>
                                        <TextField attr='cardNumberIdFilter' label={t(`${T_PREFIX}cardNumber`)}></TextField>
                                    </div>
                                    <div className={divColumnSize}>
                                        <SelectField attr="responseCodeSelected" label={t(`${T_PREFIX}responseCode`)} options={responseCodes}></SelectField>
                                    </div>
                                    <div className={divColumnSize}>
                                        <TextField attr='ticketFilter' label={t(`${T_PREFIX}ticket`)}></TextField>
                                    </div>
                                    <div className={divColumnSize}>
                                        <TextField attr='batchFilter' label={t(`${T_PREFIX}batch`)}></TextField>
                                    </div>
                                    <div className={divColumnSize}>
                                        <SelectField attr="paymentModeFilter"  label={t(`${T_PREFIX}paymentMode`)} options={paymentModes}></SelectField>
                                    </div>
                                    {WebCache.getCurrentUser()?.countryId === 1?
                                    <>
                                    <div className={divColumnSize}>
                                        <TextField attr='muIdFilter' label={t(`${T_PREFIX}muId`)}></TextField>
                                    </div>
                                    </>:<></>
                                    }
                                </div>
                            </>
                        </FormFilter>
                        <div className='row'>
                            <div className="col-md-12">
                                {UtilService.isMobilePlatform() ?
                                    <div>
                                        <div className="container">
                                            <ul className="notification">
                                                {
                                                    transactions.slice(pages.indexOf(activePage) * pageSize, (pages.indexOf(activePage) * pageSize) + pageSize).map((transaction, Tindex) => {
                                                        return (
                                                            <li>
                                                                <div className="notification-time-date mb-2 d-block d-md-none">
                                                                    <span className="date">{transaction.authDateTime}</span>
                                                                </div>
                                                                <div className={"settlementMobile notification-body transactionType-" + transaction.transactionType}>
                                                                    <div className="media mt-0">
                                                                        <div className="main-avatar avatar-md online" >
                                                                            {<img alt="Logo" className="br-7 transaction-image" src={UtilService.getImageTag(t("issuer-" + transaction.issuer).toUpperCase())} 
                                                                                onError={(e) => {
                                                                                    (e.target as HTMLImageElement).style.display = 'none'; //Oculta el logo cuando no trae una imagen valida
                                                                                }}
                                                                                ></img>
                                                                            }
                                                                        </div>
                                                                        <div className="media-body ms-3 d-flex">
                                                                            <div className="" >
                                                                                <span className={transaction.transactionType == "REV" || transaction.transactionType == "LP" || transaction.transactionType == "A" || transaction.transactionType == "D" ? "text-danger amount-label" : "amount-label"}>{Intl.NumberFormat('es-UY', {
                                                                                    style: 'currency',
                                                                                    currency: CurrencyHelper.getCurrencySymbol(transaction.currency)
                                                                                }).format(transaction.totalAmountForReport)}</span>
                                                                                <p className="mb-0 fs-13 text-muted">{t("transactionType-" + transaction.transactionType)}</p>
                                                                                <p className="mb-0 fs-13 text-muted">{transaction.cardNumber}</p>
                                                                                <p className={
                                                                                    "mb-0 fs-11 " +
                                                                                    (
                                                                                        transaction.responseCode === "00" ||
                                                                                            transaction.responseCode === "08" ||
                                                                                            transaction.responseCode === "11" ||
                                                                                            transaction.responseCode === "85" ||
                                                                                            transaction.responseCode === "LV" ||
                                                                                            transaction.responseCode === "OF"
                                                                                            ? "response-code-success"
                                                                                            : "response-code-error"
                                                                                    )
                                                                                }>
                                                                                    {transaction.responseCode
                                                                                        ? (allResponseCodes["RESPONSECODE-" + transaction.responseCode]==null?t("responseCode-" + transaction.responseCode):allResponseCodes["RESPONSECODE-" + transaction.responseCode] )
                                                                                        : "-"}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ width: "34px", height: "30px", marginLeft: "10px" }}>
                                                                            <a onClick={() => { getTicket(transaction.id, transaction.transactionType) }}>
                                                                                <i className="fa-sharp fa-solid fa-print text-primary" aria-hidden="true"></i>
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        )
                                                    })}
                                            </ul>
                                        </div>
                                        <div>
                                            <Pagination
                                                pageSize={pageSize}
                                                pageQuantity={pageQuantity}
                                                modifyMainPage={(value: number, newPages: Array<number>) => {
                                                    setMainPage(mainPage + value);
                                                    setPages(newPages);
                                                    getTransactions();
                                                }}
                                                changePage={(page: number) => setActivePage(page)}
                                                dataL={transactions.length}
                                                mainPage={mainPage}
                                            ></Pagination>
                                        </div>
                                    </div> :
                                    <CustomTable
                                        rowObjects={transactions}
                                        columnDefinitions={transactionColumns}
                                        config={{
                                            pageSize: pageSize,
                                            mode: gridFormat === "list" ? TableModeEnum.LIST : TableModeEnum.GRID,
                                            paginator: {
                                                quantity: pageQuantity,
                                                mainPage: mainPage,
                                                modifyMainPage: (value: number) => {
                                                    setMainPage(mainPage + value);
                                                    getTransactions();
                                                },
                                                pageRequest: {
                                                    Skip: 0,
                                                    Take: 0
                                                }
                                            },
                                        }}
                                    ></CustomTable>
                                }
                            </div>
                        </div>
                        <div className='row mt-4 mobileCaptcha'>
                            <div className='col-md-7'></div>
                            <div className="col-md-3 col-sm-6 d-flex justify-content-center align-items-start">
                                <CustomReCAPTCHA useCache={true} onVerify={handleCaptchaVerify} />
                            </div>
                            <div className="col-md-2 col-sm-6 d-flex justify-content-center align-items-start">
                                <Button disabled={transactions.length === 0} label='excel' className='buttonExcel' onClick={() => getTransactionsToExcel()}></Button>
                            </div>
                        </div>
                    </div>
                </div>
                <>
                    <Modal show={show} size="lg">
                        <div className="modal-content modal-content-demo">
                            <div className="modal-header bg-primary">
                                <h5 className="modal-title text-white"> {'Transacción Nro. ' + tranId}  </h5>
                                <button aria-label="Close" className="btn-close" onClick={() => setShow(false)}><span className='text-white' aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body">
                                <div className="col-md-12 mb-3">
                                    <div className="table-responsive">
                                        <table className="table text-nowrap text-md-nowrap mb-0">
                                            <thead>
                                                <tr >
                                                    <th style={{ color: "black" }}>{t("issuer")}</th>
                                                    <th style={{ color: "black" }}>{t("amount")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    issuerByTotal.map((val: IIssuerTotalDto) => {
                                                        return (
                                                            <tr >
                                                                <td>{val.issuerName}</td>
                                                                <td>{Intl.NumberFormat('es-UY', {
                                                                    style: 'currency',
                                                                    currency: val.currency === "$" ? "UYU" : "USD"
                                                                }).format(Number(val.totalAmount))}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button onClick={() => setShow(false)}
                                    className="btn btn-light"
                                    style={{
                                        backgroundColor: '#f60'
                                        ,
                                        color: 'white',
                                    }}
                                    data-bs-dismiss="modal">OK</button>
                            </div>
                        </div>
                    </Modal>
                </>

            </>
        </Page>
    );
}
export default withTranslation()(TransactionReport);
